import { Title } from '@mantine/core'

export const FrontTitle = () => {
  return (
    <Title
      className="front-title"
      styles={{
        root: {
          padding: "5%",
          borderBottom: "1px solid #404040",
          color: "white",
          textAlign: "center",
          backgroundColor: "#191919"
        }
      }}>
      Valorant Esports Archive
    </Title>
  )
}